import { render } from "./i-synchronize.vue?vue&type=template&id=023889a4"
import script from "./i-synchronize.vue?vue&type=script&lang=js"
export * from "./i-synchronize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__